import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft, Search } from 'lucide-react';

export const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page non trouvée | CAMBC Conseils</title>
        <meta name="description" content="La page que vous recherchez n'existe pas. Retournez à l'accueil du Cabinet CAMBC Conseils." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen pt-32 pb-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <div className="mb-8">
            <div className="text-9xl font-bold text-slate-200">404</div>
          </div>
          
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Page introuvable
          </h1>
          
          <p className="text-lg text-slate-600 mb-8">
            Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link to="/">
              <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white">
                <Home className="mr-2" size={18} />
                Retour à l'accueil
              </Button>
            </Link>
            <Link to="/contact">
              <Button size="lg" variant="outline" className="border-slate-300">
                <ArrowLeft className="mr-2" size={18} />
                Nous contacter
              </Button>
            </Link>
          </div>

          <div className="bg-slate-100 rounded-xl p-6">
            <h2 className="font-semibold text-slate-900 mb-4 flex items-center justify-center gap-2">
              <Search size={18} />
              Pages populaires
            </h2>
            <div className="flex flex-wrap justify-center gap-3">
              <Link to="/assurance-temporaire" className="text-blue-600 hover:underline text-sm">
                Assurance Temporaire
              </Link>
              <span className="text-slate-300">•</span>
              <Link to="/services" className="text-blue-600 hover:underline text-sm">
                Nos Services
              </Link>
              <span className="text-slate-300">•</span>
              <Link to="/carte-grise" className="text-blue-600 hover:underline text-sm">
                Carte Grise
              </Link>
              <span className="text-slate-300">•</span>
              <Link to="/quote" className="text-blue-600 hover:underline text-sm">
                Demander un devis
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
